import {tr} from "@vue-components/helpers/I18nPluginHelper.js";
import MapBaseClass from "./MapBaseClass.js";

export default class MapBuilding extends MapBaseClass {
    constructor(data) {
        super(data);
    }

    getShortName() {
        if (tr(this.shortName)) {
            return tr(this.shortName);
        } else {
            return this.getName();
        }
    }

    getName() {
        if (tr(this.label)) {
            return tr(this.label);
        } else {
            return tr(this.name);
        }
    }

    isOnFloor(floorId) {
        return this.floorId === floorId ||
            (this.floors.multiple && this.floors.list.hasOwnProperty(floorId));
    }

    isInside(coord) {
        return this.x - this.width / 2 <= coord.x && coord.x <= this.x + this.width / 2 &&
            this.y - this.height / 2 <= coord.y && coord.y <= this.y + this.height / 2;
    }

    getColor() {
        return this.color || `#ccc`;
    }
}
